import { useState } from "react";
import { AlertTriangle, ChevronDown } from "lucide-react";
import { AppError, userMessageFor } from "@/lib/errors";

export default function ErrorBanner({ error }: { error: AppError }) {
  const [open, setOpen] = useState(false);
  const m = userMessageFor(error);

  return (
    <div className="border border-destructive/40 bg-destructive/10 text-destructive rounded-lg p-3">
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-5 w-5 mt-0.5" />
        <div className="flex-1">
          <div className="font-semibold">{m.title}</div>
          {m.tips?.length > 0 && (
            <ul className="list-disc pl-5 text-sm mt-1">
              {m.tips.map((t, i) => <li key={i}>{t}</li>)}
            </ul>
          )}
          <button
            className="mt-2 inline-flex items-center gap-1 text-xs underline underline-offset-4"
            onClick={() => setOpen(v => !v)}
          >
            {open ? "Ocultar detalhes" : "Ver detalhes técnicos"}
            <ChevronDown className={`h-3 w-3 transition ${open ? "rotate-180" : ""}`} />
          </button>
          {open && (
            <pre className="mt-2 text-xs whitespace-pre-wrap text-foreground/80">
              {error.code}: {error.message}
              {error?.details ? `\n${JSON.stringify(error.details, null, 2)}` : ""}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
}
